// extracted by mini-css-extract-plugin
export default {"root":"confirm_delete_modal-module___root___be16621f"};